/**
 * Organizations API
 */

import { apiClient } from "./apiClient";

export const organizationsAPI = {
  list: (params = {}) => apiClient.get("/organizations/", { params }),
  retrieve: (orgId) => apiClient.get(`/organizations/${orgId}/`),
  getAccessible: () => apiClient.get("/organizations/accessible/"),
  create: (payload) => apiClient.post("/organizations/", payload),
  update: (orgId, payload) =>
    apiClient.patch(`/organizations/${orgId}/`, payload),
  remove: (orgId) => apiClient.delete(`/organizations/${orgId}/`),
  assignments: {
    list: (params = {}) =>
      apiClient.get("/organizations/assignments/", { params }),
    create: (payload) => apiClient.post("/organizations/assignments/", payload),
    remove: (assignmentId) =>
      apiClient.delete(`/organizations/assignments/${assignmentId}/`),
  },
};
